import { render, staticRenderFns } from "./relateNewHouseDialog.vue?vue&type=template&id=e23bc4cc&scoped=true"
import script from "./relateNewHouseDialog.vue?vue&type=script&lang=js"
export * from "./relateNewHouseDialog.vue?vue&type=script&lang=js"
import style0 from "./relateNewHouseDialog.vue?vue&type=style&index=0&id=e23bc4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23bc4cc",
  null
  
)

export default component.exports